import React from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import { Block, Text } from '../../../../../../components';
import { BackButton } from '../../../../components';
import Spinner from '../../../../../../components/Spinner';
import Step from '../../../requests/UpdatePhoto/Register/components/Step';
import constants from '../../../../constants';
import requestInProgressImage from '../../../../../../../assets/illustrations/request_in_progress.svg';
import requestInProgressDskImage from '../../../../../../../assets/illustrations/procedures/cards/progress_dsk.svg';
import documentSuccessImage from '../../../../../../../assets/illustrations/procedures/cards/document-success.svg';
import documentSuccessDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-success-dsk.svg';
import documentFailedImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed.svg';
import documentFailedDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed-dsk.svg';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import ResumeDetail from '@/presentation/modules/procedures/components/Resume';
import CardProgress from '@/presentation/reusables/CardProgress';
import { TextTitle } from '../../../certificates-constancies/type1/register/components';
import warningAlertIcon from '../../../../../../../assets/icons/warning-alert.svg';
import WarningMessage from '@/presentation/reusables/WarningMessage';
import AgreementsInfoCard from '../components/AgreementsInfoCard';
import DateHelpers from '@/core/helpers/DateHelper';

const Container = styled.div`
  font-size: 14px;
  color: #161d1f;

  span {
    color: #4f6168;
  }
`;
const Button = styled.button`
  display: flex;
  width: Fill (115px) px;
  height: Hug (44px) px;
  padding: 10px 24px 10px 16px;
  gap: 8px;
  border-radius: 4px;
  background: #ffffff;
  color: #5b36f2;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  align-items: center;
  border: 1px solid #5b36f2;
  margin: 16px 0px 0px 0px;
`;

const AgreementsProgressView = (props: any) => {
  const {
    procedure,
    isLoading,
    request,
    handleBack,
    requirementsAuto,
    documentsList,
    handleReviewInPayments
  } = props;
  const safeDocumentsList = documentsList ?? [];

  const evalStatus = () =>
    constants.procedureStatus.Agreement.find(
      (s: any) => s.name === request?.status.status
    );

  return (
    <div data-testid="agreements-progress-view">
      <ContainerProcedure>
        <SubContainer style={{ marginBottom: 24 }}>
          <Block
            customized
            width="100%"
            display="flex"
            justifyContent="flex-start"
            padding="16px 0 0 0"
          >
            <BackButton onClick={handleBack} fontSize="14px" />
          </Block>
        </SubContainer>
        {isLoading && <Spinner />}
        {request && !isLoading && (
          <SubContainer>
            <AgreementsInfoCard
              name={procedure?.name}
              status={request?.status.status}
              statusText={request?.status.name}
              amount={Number(procedure?.amount)}
              duration={procedure?.duration}
              date={procedure?.endDate}
              requirementsAuto={requirementsAuto}
              documentsList={safeDocumentsList}
            />
            <TextTitle title="Progreso" />
            <Block
              data-testid="agreements-progress-block"
              customized
              padding={isMobile ? '20px 0px 0px 8px' : '20px 0px 0px 16px'}
            >
              <Step name={procedure?.steps[0].name} order={1} isComplete>
                <Container>
                  <span style={{ fontWeight: '700', color: '#161D1F' }}>
                    Detalle de solicitud:
                  </span>
                  <ul style={{ marginLeft: 24, paddingRight: 14 }}>
                    <li style={{ listStyle: 'initial' }}>
                      <span style={{ color: '#161D1F' }}>
                        Tipo de beneficiario:
                      </span>
                      <span
                        style={{
                          fontWeight: '700',
                          color: '#161D1F',
                          marginLeft: 4
                        }}
                      >
                        {procedure?.detail?.certificateDetail?.beneficiaryName}
                      </span>
                    </li>
                    <li style={{ listStyle: 'initial' }}>
                      {`${procedure?.detail?.certificateDetail?.documentCount} documentos adjuntos.`}
                    </li>
                  </ul>
                </Container>
              </Step>
              <Step
                name={procedure.steps[1].name}
                order={procedure.steps[1].order}
                // date={procedure.steps[1].date}
                isComplete={procedure.steps[1].isComplete}
                isCurrent={procedure.steps[1].isCurrent}
                isLast
              >
                <ResumeDetail
                  data={{
                    requestDate: DateHelpers.formatDateString(
                      procedure?.detail?.certificateDetail?.requestDate
                    ),
                    probableDateOfAttention:
                      procedure?.detail?.certificateDetail
                        ?.probableDateOfAttention,
                    responseDate:
                      procedure?.detail?.certificateDetail?.responseDate?.replace(
                        /\./g,
                        ''
                      )
                  }}
                  labels={[
                    'Fecha de solicitud',
                    request.status.status === 'PENDIENTE'
                      ? 'Fecha estimada de respuesta'
                      : 'Fecha de respuesta'
                  ]}
                  fields={[
                    'requestDate',
                    request.status.status === 'PENDIENTE'
                      ? 'probableDateOfAttention'
                      : 'responseDate'
                  ]}
                  fontWeight="700"
                />
                {!evalStatus()?.isComplete ? (
                  <CardProgress
                    image={[requestInProgressImage, requestInProgressDskImage]}
                    title={`Tu solicitud está pendiente`}
                    subtitle={'Estamos revisando tu solicitud.'}
                  >
                    <Block
                      customized
                      backgroundColor="#d5e5f0"
                      borderRadius="8px"
                      gap="8px"
                      flexDirection="row"
                      padding="16px"
                      margin="16px 0px 0px 0px"
                    >
                      <div
                        style={{
                          minWidth: '24px',
                          minHeight: '24px',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <img
                          src={warningAlertIcon}
                          alt="warningAlertIcon"
                          style={{
                            width: '20px',
                            height: '20px',
                            maxWidth: 'none'
                          }}
                        />
                      </div>
                      <Text
                        fontWeight="400"
                        fontSize="12px"
                        lineHeight="20px"
                        color="#161D1F"
                      >
                        Te avisaremos por notificaciones de UTP+app cuando
                        tengas una respuesta.
                      </Text>
                    </Block>
                  </CardProgress>
                ) : (
                  <></>
                )}
                {evalStatus()?.isComplete && evalStatus()?.isApproved && (
                  <>
                    <CardProgress
                      image={[documentSuccessImage, documentSuccessDskImage]}
                      title={`Tu solicitud procede`}
                      subtitle={
                        'Tu convenio ha sido aplicado correctamente para este ciclo.'
                      }
                    >
                      <Block
                        customized
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <Button onClick={handleReviewInPayments}>
                          Revisar en pagos
                        </Button>
                      </Block>
                    </CardProgress>
                    <WarningMessage
                      message="Si cumples con los requisitos, puedes renovarlo el próximo ciclo, presentando una nueva solicitud."
                      styledProps={{
                        background: '#D5E5F0',
                        padding: '16px',
                        alignItems: 'flex-start',
                        margin: '16px 0px 0px 0px',
                        fontSize: '12px',
                        borderRadius: '8px',
                        iconSize: 13
                      }}
                    />
                  </>
                )}
                {evalStatus()?.isComplete && !evalStatus()?.isApproved && (
                  <>
                    <CardProgress
                      image={[documentFailedImage, documentFailedDskImage]}
                      title={`Tu solicitud no procede`}
                      subtitle={
                        'El motivo es falta de información para poder aprobarla. Revisa la lista de requisitos y documentos de sustento.'
                      }
                    />
                    <WarningMessage
                      message="Si estás dentro del plazo, podrías presentar una nueva solicitud."
                      styledProps={{
                        background: '#D5E5F0',
                        padding: '16px',
                        alignItems: 'flex-start',
                        margin: '16px 0px 0px 0px',
                        fontSize: '12px',
                        borderRadius: '8px',
                        iconSize: 13
                      }}
                    />
                  </>
                )}
              </Step>
            </Block>
          </SubContainer>
        )}
      </ContainerProcedure>
    </div>
  );
};

export default AgreementsProgressView;
